import { render, staticRenderFns } from "./VisitSubmissionDetails.vue?vue&type=template&id=21c0e7e4&scoped=true&"
import script from "./VisitSubmissionDetails.vue?vue&type=script&lang=js&"
export * from "./VisitSubmissionDetails.vue?vue&type=script&lang=js&"
import style0 from "./VisitSubmissionDetails.vue?vue&type=style&index=0&id=21c0e7e4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c0e7e4",
  null
  
)

export default component.exports